import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'

import myPicture from "../../../assets/images/michael.jpg";
import TechStack from '../portfoliopage/TechStack'
import techIcons from '../../../js/portfolio/techstack'

const About = () => {
    const allTechKeys = Object.keys(techIcons);

    return(
        <section id="About">
            <div className="about-wrapper">
                <h1 className='section-head'>A Little About Me</h1>
                <div className="about-content">
                    <div className="about-me">
                        <div className="about-me-picture">
                            <img src={myPicture} alt="" />
                        </div>
                        <div className="about-myself">
                            <div className="about-personal">
                                <h1>Ignatius Michael Dinata</h1>
                                <h3>Jakarta, Indonesia</h3>
                                <div className="about-introduction">
                                    I'm a Master's graduate at Bina Nusantara University, specializing in Computer Science. Previously, I pursued my Bachelor's degree in the same field. I am a team player, and I am also known to be an organized person. I enjoy learning new things and developing myself through the challenges presented. Currently, I am setting myself in the field of Front-End Development.
                                    <a href="https://drive.google.com/file/d/1xAc3shq9-cAMkRlqa9z8Hzc_2WRadXa6/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                                        <div className="about-button">
                                            Check My CV
                                            <FontAwesomeIcon className='button-icon' size='1x' icon={faDownload} />
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="about-techstack">
                                <h1>Techstacks</h1>
                                <TechStack stack={allTechKeys} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About